import React from "react";
import { Icon } from "@iconify/react";
import "./UpgradePlan.scss";

const UpgradePlan = ({ productName, description, onClose }) => {
  const handlePurchase = () => {
    window.open("https://www.ourdept.in", "_blank", "noopener,noreferrer");
  };

  const safeClose = () => {
    if (typeof onClose === "function") {
      onClose();
    }
  };

  return (
    <div
      className="upgrade-overlay"
      onClick={(e) => {
        e.stopPropagation();
        safeClose();
      }}
      role="dialog"
      aria-modal="true"
    >
      <div className="upgrade-modal" onClick={(e) => e.stopPropagation()}>
        <div className="upgrade-header">
          <h3>
            Upgrade to Unlock <span>{productName || "This Feature"}</span>
          </h3>

          <button
            type="button"
            className="close-btn"
            onClick={(e) => {
              e.stopPropagation();
              safeClose();
            }}
          >
            <Icon icon="mdi:close" />
          </button>
        </div>

        <div className="upgrade-card">
          <div className="upgrade-icon" />
          <div className="upgrade-info">
            <h4>{productName}</h4>
            <p>{description}</p>
          </div>
        </div>

        <div className="upgrade-actions">
          <button
            type="button"
            className="btn-secondary"
            onClick={(e) => {
              e.stopPropagation();
              safeClose();
            }}
          >
            Maybe Later
          </button>

          <button
            type="button"
            className="btn-primary"
            onClick={handlePurchase}
          >
            <Icon icon="mdi:cart-outline" />
            Purchase Now
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpgradePlan;
